import { Image, ImageSourcePropType } from 'react-native';

export default function generateURI(uri: ImageSourcePropType | string): string {
  return typeof uri === 'string' ? uri : Image.resolveAssetSource(uri).uri;
}
